import { GetApiData } from './fetchConfig';

export const useNationalities = () => GetApiData('nationalities');
